const microsoftColors = ['#12B8FF', '#01DC03', '#FD4499', '#DF19FB', '#FF3A06']

const getColorForMember = (index) => {
  return microsoftColors[index % microsoftColors.length]
}

export default getColorForMember
